module.exports = __webpack_public_path__ + "img/OBCINA SEZANA.44ee2312.png";